var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpublishedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25581_15040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 8.75001C5.46007 8.75001 5.83317 8.37691 5.83317 7.91668C5.83317 7.45644 5.46007 7.08334 4.99984 7.08334C4.5396 7.08334 4.1665 7.45644 4.1665 7.91668C4.1665 8.37691 4.5396 8.75001 4.99984 8.75001Z",
    fill: "#9D9DE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 1.25C4.5415 1.25 4.1665 1.625 4.1665 2.08333V5.41667C4.1665 5.875 4.5415 6.25 4.99984 6.25C5.45817 6.25 5.83317 5.875 5.83317 5.41667V2.08333C5.83317 1.625 5.45817 1.25 4.99984 1.25Z",
    fill: "#9D9DE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25581_15040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublishedIcon);
export default __webpack_public_path__ + "static/media/unpublished-icon.954c7947.svg";
export { ForwardRef as ReactComponent };